import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getFunds } from '../funds.routes';
import type { RSPageFund } from '../../api.types';
import { GetFundsParams } from '../types';

// Query Hooks

/**
 * Hook to fetch funds data
 * @param params - Query parameters including fundTypes, rsResources (optional), and raptorPlatformId (optional)
 * @param options - Additional query options extending UseQueryOptions
 */
export const useFunds = (
  params: GetFundsParams,
  options?: Omit<
    UseQueryOptions<
      RSPageFund[],
      Error,
      RSPageFund[],
      (string | string[] | undefined)[]
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: [
      'funds',
      params.fundTypes,
      params.rsResources,
      params.raptorPlatformId,
    ],
    queryFn: () => getFunds(params),
    enabled:
      options?.enabled !== undefined
        ? options.enabled
        : !!params.fundTypes && !!params.rsResources?.length,
    staleTime: options?.staleTime ?? 5 * 60 * 1000, // 5 minutes
  });
};
